<template>
    <div class="DocumentDataReviewPropertyCard" :class="{ 'DocumentDataReviewPropertyCard--small': isSmall }">
        <div class="DocumentDataReviewPropertyCard__header">
            <DocumentDataReviewBackgroundIcon :icon="icon" size="xs" />
            <span class="DocumentDataReviewPropertyCard__label">{{ label }}</span>
        </div>
        <span class="DocumentDataReviewPropertyCard__value">{{ value }}</span>
    </div>
</template>

<style lang="scss">
.DocumentDataReviewPropertyCard {
    position: relative;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid var(--eidSecureBlue-10);
    background-color: var(--eidBgGrayTones-lightest);
    transition: box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
        box-shadow: 0 1px 2px 0 rgba(16, 34, 140, 0.05), 0 1.5px 6px 0 rgba(16, 34, 140, 0.06);
    }

    &__header {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        margin-bottom: 0.5rem;
    }

    &__value {
        font-size: 13px;
        color: var(--eidDarkBlue);
        font-weight: 500;
        line-height: 1.25;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        word-wrap: break-word;
    }

    &__label {
        font-size: 11px;
        color: var(--eidTechGray);
        font-weight: 500;
        text-transform: uppercase;
    }

    &--small {
        padding: 8px;

        .DocumentDataReviewPropertyCard__value {
            font-size: 11px;
        }

        .DocumentDataReviewPropertyCard__label {
            font-size: 10px;
        }
    }
}
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';

    import DocumentDataReviewBackgroundIcon from '@/modules/document-data-review/components/commons/document-data-review/sub-components/DocumentDataReviewBackgroundIcon.vue';

    export default defineComponent({
        name: 'DocumentDataReviewPropertyCard',
        components: {
            DocumentDataReviewBackgroundIcon,
        },
        props: {
            label: {
                type: String as PropType<string>,
                required: true,
            },
            value: {
                type: String as PropType<string>,
                required: true,
            },
            icon: {
                type: Object as PropType<IconDefinition>,
                required: true,
            },
            isSmall: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
        },
    });
</script>
